import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { FluxoCaixaRequest } from '../../requests/financas/fluxo-caixa.request';
import { FluxoCaixaDetalheDiarioRequest } from '../../requests/financas/fluxo-caixa-detalhe-diario.request';
import { SaveRelatorioFiltroFavoritoRequest } from '../../requests/financas/save-relatorio-filtro-favorito.request';
import { SaveRelatorioFiltroFavoritoResponse } from '../../responses/financas/relatorio-filtro-favorito.response';
import {
    FluxoCaixaLookupResponse,
    FluxoCaixaDiarioResponse,
    FluxoCaixaMensalResponse,
    FluxoCaixaDetalheDiarioResponse
} from '../../responses/financas/fluxo-caixa.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root'
})
export class FluxoCaixaService extends CommonService {
    private readonly apiUrl = `${environment.urlApiFinancas}FluxoCaixa`;

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getLookup(): Observable<FluxoCaixaLookupResponse> {
        return this.httpClient
            .get<FluxoCaixaLookupResponse>(`${this.apiUrl}/lookup`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getDiario(request: FluxoCaixaRequest): Observable<FluxoCaixaDiarioResponse> {
        return this.httpClient
            .post<FluxoCaixaDiarioResponse>(`${this.apiUrl}/diario`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getMensal(request: FluxoCaixaRequest): Observable<FluxoCaixaMensalResponse> {
        return this.httpClient
            .post<FluxoCaixaMensalResponse>(`${this.apiUrl}/mensal`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getDetalheDiario(request: FluxoCaixaDetalheDiarioRequest): Observable<FluxoCaixaDetalheDiarioResponse> {
        return this.httpClient
            .post<FluxoCaixaDetalheDiarioResponse>(`${this.apiUrl}/diario/detalhe`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public saveFavorito(request: SaveRelatorioFiltroFavoritoRequest): Observable<SaveRelatorioFiltroFavoritoResponse> {
        return this.httpClient
            .post<SaveRelatorioFiltroFavoritoResponse>(`${this.apiUrl}/favorito`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteFavorito(idRelatorioFiltroFavorito: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(`${this.apiUrl}/favorito/${idRelatorioFiltroFavorito}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
